let tT;

export function toast(msg){const t=document.getElementById('toast');document.getElementById('toastMsg').textContent=msg;t.classList.add('show');clearTimeout(tT);tT=setTimeout(()=>t.classList.remove('show'),2200)}

/* ---------- ROUTER ---------- */

export const C=()=>document.getElementById('content');

export const spinner=`<div class="loading"><div class="spin"></div>Loading…</div>`;

export const emptyRow=(cols,msg,icon)=>`<tr><td colspan="${cols}" class="empty"><span class="eic" data-icon="${icon||'inbox'}" data-size="30"></span>${msg}</td></tr>`;

/* ============================================================
   DASHBOARD  —  DashBoardCards + conveyorReading + per-date chart
   ============================================================ */
